export default "__VITE_ASSET__BQa5IiKJ__"